import { lazy } from "react";

// Material Dashboard 2 React layouts
const Dashboard = lazy(() => import("layouts/dashboard"));
const Tables = lazy(() => import("layouts/tables"));
const Billing = lazy(() => import("layouts/billing"));
const RTL = lazy(() => import("layouts/rtl"));
const Notifications = lazy(() => import("layouts/notifications"));
const Profile = lazy(() => import("layouts/profile"));
const SignIn = lazy(() => import("layouts/authentication/sign-in"));
const SignUp = lazy(() => import("layouts/authentication/sign-up"));

const Souche = lazy(() => import("layouts/souche"));
const CreateSouche = lazy(() => import("layouts/souche/create"));
const EditSouche = lazy(() => import("layouts/souche/edit"));
// espece
const Espece = lazy(() => import("layouts/espece"));
const CreateEspece = lazy(() => import("layouts/espece/create"));
const EditEspece = lazy(() => import("layouts/espece/edit"));
// guide
const Guide = lazy(() => import("layouts/guide"));
const CreateGuide = lazy(() => import("layouts/guide/create"));
const EditGuide = lazy(() => import("layouts/guide/edit"));
// parametres
const Parametre = lazy(() => import("layouts/parametre"));
const CreateParametre = lazy(() => import("layouts/parametre/create"));
const EditParametre = lazy(() => import("layouts/parametre/edit"));
// medicaments
const Medicaments = lazy(() => import("layouts/medicament"));
const CreateMedicament = lazy(() => import("layouts/medicament/create"));
const EditMedicament = lazy(() => import("layouts/medicament/edit"));
// Diseases
const Diseases = lazy(() => import("layouts/disease"));
const CreateDisease = lazy(() => import("layouts/disease/create"));
const EditDisease = lazy(() => import("layouts/disease/edit"));
// units
const Units = lazy(() => import("layouts/unit"));
const CreateUnit = lazy(() => import("layouts/unit/create"));
const EditUnit = lazy(() => import("layouts/unit/edit"));
// follows
const Follows = lazy(() => import("layouts/follow"));
const ShowFollows = lazy(() => import("layouts/follow/show"));

// table

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  // especes
  {
    type: "collapse",
    name: "Especes",
    key: "especes",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/especes", // Base path for preferences
    component: <Espece />,
    isPrivate: true,
  },
  {
    // type: "collapse",
    name: "Create Espece",
    key: "create-Espece",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/espece/create",
    component: <CreateEspece />,
    isPrivate: true,
  },
  {
    // type: "collapse",
    name: "Edit Espece",
    key: "edit-espece",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/espece/edit/:id",
    component: <EditEspece />,
    isPrivate: true,
  },
  // souche
  {
    type: "collapse",
    name: "Souches",
    key: "souches",
    icon: <Icon fontSize="small">yard</Icon>,
    route: "/souches", // Base path for preferences
    component: <Souche />,
    isPrivate: true,
  },
  {
    type: "",
    name: "Create Souche",
    key: "create-Souche",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/souche/create",
    component: <CreateSouche />,
    isPrivate: true,
  },
  {
    type: "",
    name: "Edit Souche",
    key: "edit-Souche",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/souche/edit/:id",
    component: <EditSouche />,
    isPrivate: true,
  },
  // guide
  {
    type: "collapse",
    name: "Guides",
    key: "guides",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/guides", // Base path for preferences
    component: <Guide />,
    isPrivate: true,
  },
  {
    type: "",
    name: "Create Guide",
    key: "create-guide",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/guide/create",
    component: <CreateGuide />,
    isPrivate: true,
  },
  {
    type: "",
    name: "Edit Guide",
    key: "edit-guide",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/guide/edit/:id",
    component: <EditGuide />,
    isPrivate: true,
  },
  // parametres
  {
    type: "collapse",
    name: "Parametres",
    key: "parametres",
    icon: <Icon fontSize="small">room_preferences</Icon>,
    route: "/parametres",
    component: <Parametre />,
    isPrivate: true,
  },
  // create parametres
  {
    type: "",
    name: "Create Parametres",
    key: "create-Parametres",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/parametre/create",
    component: <CreateParametre />,
    isPrivate: true,
  },
  // edit parametres
  {
    type: "",
    name: "Edit Parametres",
    key: "edit-Parametres",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/parametre/edit/:id",
    component: <EditParametre />,
    isPrivate: true,
  },
  // // Les médicamentes
  // {
  //   type: "collapse",
  //   name: "Medicaments",
  //   key: "medicaments",
  //   icon: <Icon fontSize="small">shopping_bag</Icon>,
  //   route: "/medicament",
  //   component: <Medicaments />,
  // },
  // // create medicaments
  // {
  //   type: "",
  //   name: "Create Medicament",
  //   key: "create-medicament",
  //   icon: <Icon fontSize="small">add_circle</Icon>,
  //   route: "/medicament/create",
  //   component: <CreateMedicament />,
  // },
  // // edit medicaments
  // {
  //   type: "",
  //   name: "Edit Medicament",
  //   key: "edit-medicament",
  //   icon: <Icon fontSize="small">edit</Icon>,
  //   route: "/medicament/edit/:id",
  //   component: <EditMedicament />,
  // },
  // Diseases
  {
    type: "collapse",
    name: "Diseases",
    key: "diseases",
    icon: <Icon fontSize="small">bug_report</Icon>,
    route: "/diseases",
    component: <Diseases />,
    isPrivate: true,
  },
  // create diseases
  {
    type: "",
    name: "Create Disease",
    key: "create-disease",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/disease/create",
    component: <CreateDisease />,
    isPrivate: true,
  },
  // edit diseases
  {
    type: "",
    name: "Edit Disease",
    key: "edit-disease",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/disease/edit/:id",
    component: <EditDisease />,
    isPrivate: true,
  },
  // follows
  {
    type: "collapse",
    name: "follows",
    key: "follows",
    icon: <Icon fontSize="small">follow_the_signs</Icon>,
    route: "/follows",
    component: <Follows />,
    isPrivate: true,
  },

  // show follows
  {
    type: "",
    name: "Show follows",
    key: "Show-follows",
    icon: <Icon fontSize="small">show</Icon>,
    route: "/follow/show/:id",
    component: <ShowFollows />,
    isPrivate: true,
  },
  // units
  {
    type: "collapse",
    name: "Units",
    key: "units",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/units",
    component: <Units />,
    isPrivate: true,
  },
  // create units
  {
    type: "",
    name: "Create Unit",
    key: "create-unit",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/unit/create",
    component: <CreateUnit />,
    isPrivate: true,
  },
  // edit units
  {
    type: "",
    name: "Edit Unit",
    key: "edit-unit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/unit/edit/:id",
    component: <EditUnit />,
    isPrivate: true,
  },

  // Profile
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    isPrivate: true,
  },
  {
    // type: "collapse",
    // name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    isPrivate: false,
  },
  {
    // type: "collapse",
    // name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
    isPrivate: false,
  },
];

export default routes;
